import React, { useEffect, useRef, useState } from "react";
import {
  addCollegeFacility,
  getFacilities,
  getFacilitiesByCollege,
  updateCollegeDetails,
} from "../../../Services/HomeService";
import toast from "react-hot-toast";
import Select from "react-select";
import HttpClientXml from "../../../utils/HttpClientXml";

const CollegeUniversityCampusStep2 = ({ data, setData, setCurrentStep, currentStep }) => {

  const [formDataLoading, setFormDataLoading] = useState(false);
  const [value, setValue] = useState([]);

  console.log("CDE31", data?._id);

  const handleBack = (e) => {
    e?.preventDefault();
    setCurrentStep(currentStep - 1)
  }

  const handleUpdate = async (e) => {
    e?.preventDefault();
    const updateData = {
      collegeId: data?._id,
      facilityId: value.map((item) => item.value)
    }

    console.log("POL29",updateData);
    // return
    
    try {
      setFormDataLoading(true);
      const res = await addCollegeFacility(updateData);
      console.log("CDR35", res);
      if (res?.success) {
        
        setCurrentStep(currentStep + 1)
      } else {
        toast.error(res?.message);
        setFormDataLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add College.");
      console.error("Error adding College:", error);
      setFormDataLoading(false);
    }
  };

  const [facilities, setFacilities] = useState([])
  const fetchFacilities = async () => {
    try {
      const res = await getFacilities();
      console.log("CDT69", res?.data);
      if (res?.status) {
        const data = res?.data.map((item) => ({
          value: item._id,
          label: item.name,
        }));
        setFacilities(data);
      } else {
        toast.error("Error while Fetching States Data");
      }
    } catch (error) {
      toast.error("failed to fetch States Data");
      console.error("Error fetching State:", error);
    }
  };

  const fetchCollegeFacilities = async (id) => {
    try {
      const res = await getFacilitiesByCollege(id);
      console.log("CFO74", res?.data?.facilities);
      if (res?.status) {
        const data = res?.data?.facilities.map((item) => ({
          value: item._id,
          label: item.name,
        }));
        setValue(data);
      } else {
        toast.error("Error while Fetching States Data");
      }
    } catch (error) {
      toast.error("failed to fetch States Data");
      console.error("Error fetching State:", error);
    }
  };

  useEffect(() => {
    fetchFacilities()
    fetchCollegeFacilities(data?._id)
  }, [])


  return (
    <>

      <section className="chartBox_area">
        <form
          onSubmit={(e) => {
            handleUpdate(e);
          }}
        >
          <div className="row d-flex justify-content-center">

            <div className="col-md-12 mt-3">
              <label htmlFor="name">
                Facilities<span className="text-danger">*</span>
              </label>
              <Select
                isMulti
                options={facilities}
                value={value}
                onChange={(selected) => setValue(selected || [])}
                placeholder="Select facilities..."
                // styles={customStyles}
                closeMenuOnSelect={false}
                hideSelectedOptions={true}
              />
            </div>



          </div>
          <div className=" d-flex justify-content-end">
            {
              currentStep > 1 &&
              <button
                type="button"
                className="btn mt-3"
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                  marginRight: "15px"
                }}
                onClick={(e) => handleBack(e)}
              >Back
              </button>
            }

            <button
              disabled={formDataLoading}
              type="submit"
              className="btn mt-3"
              style={{
                background: "rgb(133, 218, 79)",
                borderRadius: "13px",
              }}
            >
              {formDataLoading
                ? "Saving..."
                // : "Add College/University"
                : `Save & Continue`
              }
            </button>
          </div>
        </form>
      </section>

    </>
  );
};

export default CollegeUniversityCampusStep2;
